module.exports = __webpack_public_path__ + "img/ccc.1eea5671.jpg";